import { cva } from 'class-variance-authority';

export const selectSurfaceVariants = cva('bg-snow-50', {
  variants: {
    width: {
      content: 'w-auto',
      full: 'w-full',
    },
  },
  defaultVariants: {
    width: 'content',
  },
});

export const selectDropdownContentVariants = cva('flex max-h-[450px] flex-col overflow-hidden bg-snow-50', {
  variants: {
    mode: {
      flat: '',
      tree: '',
    },
  },
  defaultVariants: {
    mode: 'flat',
  },
});

export const selectDropdownPaperVariants = cva('mt-0.5 rounded border border-ash-900', {
  variants: {
    mode: {
      flat: '',
      tree: 'rounded-none shadow-md',
    },
  },
  defaultVariants: {
    mode: 'flat',
  },
});

export const selectSearchVariants = cva('shrink-0 p-2', {
  variants: {
    mode: {
      flat: '',
      tree: '',
    },
  },
});

export const selectFooterVariants = cva('flex shrink-0 justify-end gap-2 border-t border-snow-500 bg-snow-50 p-3');
